import type { MetaFunction } from '@remix-run/cloudflare';

import type { LinksFunction } from '@remix-run/node';
import stylesheet from '../tailwind.css?url';
import Sprite from '../sprites/sprite';

import { Banner } from '../components/banner/banner';
import { getPrefersReducedMotion } from '../accessibility/motion';
import { VYUKHeader } from '../components/header/vy-uk-header';
import { FooterSection } from '../sections/footer';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: stylesheet }];

export const meta: MetaFunction = () => {
  return [
    { title: 'Vihangam Yog UK' },
    {
      name: 'description',
      content: 'The United Kingdom institute of Vihangam Yog',
    },
  ];
};

const SCROLL_OFFSET = 60;

export const goToSelector = (selector: string) => {
  const element = document.getElementById(selector);
  if (!element) return;
  const prefersReducedMotion = getPrefersReducedMotion();

  window.scrollTo({
    behavior: prefersReducedMotion ? 'instant' : 'smooth',
    top: element.getBoundingClientRect().top - SCROLL_OFFSET,
  });
};

export const nav = [
  {
    title: 'Benefits',
    link: 'benefits-section',
  },
  {
    title: 'The Masters',
    link: 'Masters-section',
  },
  {
    title: 'Faq',
    link: 'faq-section',
  },
  {
    title: 'Donate',
    link: 'donate-section',
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="w-full h-full relative">
      <Banner
        icon={<Sprite name="audio" width={34} height={26} className="w-6 h-6" />}
        announcement={
          <p>
            Tune in on{' '}
            <a
              href="https://rangoliradio.com/listen-live"
              target="_blank"
              className="underline text-blue-500"
              rel="noreferrer"
            >
              Rangoli Radio
            </a>{' '}
            at 5PM GMT, on the 25th of May
          </p>
        }
      />
      <VYUKHeader showNav={false} />
      <main className="mt-20 mb-16 sm:mt-36 w-full flex flex-col items-center">
        <p className="text-2xl text-center max-w-[95%] font-display font-bold m-auto">
          Privacy Policy
        </p>
        <div className="text-left m-auto mt-6 px-6">
          <p>
            We are committed to protecting your privacy. We will only use the information
            that we collect about you lawfully (in accordance with the Data Protection Act
            1998). We reserve the right to make changes to this policy over time, but our
            website <span className="underline">vihangamyog.uk/privacy-policy</span> will
            have our latest policy at all times.
          </p>
          <p className="mt-4">
            We collect information about you only to provide the best experience possible.
          </p>
          <p className="mt-4">
            The only information we collect about you is in your inquiry:
          </p>
          <ul>
            <li>• Your area of interest</li>
            <li>• Your name</li>
            <li>• Email address</li>
          </ul>
          <p className="mt-4">
            We will never collect sensitive information about you without your explicit
            consent. The information we hold will be accurate and up to date. You can
            check the information that we hold about you by emailing us at{' '}
            <span className="underline"> info@vihangamyog.uk</span>. If you find any{' '}
            inaccuracies we will delete or correct it promptly.
          </p>
          <p className="mt-4">
            The personal information which we hold will be held securely in accordance
            with our internal security policy and the law. We do not transfer your
            information to any Third Party services.
          </p>
        </div>
      </main>
      <FooterSection showInquiry={false} />
    </div>
  );
}
